<script lang="ts">
    import { Col ,Alert} from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import {Dismissing, DismissingMessage} from "../../../utils/Constant/Constant";
    import data from "../../../Data/ComponentData/Ui-kits/Alert/Alert.json"
</script>
<Col sm="12" xl="6">
    <Card cardProps="height-equal" cardHeader2props="pb-0">
      <div slot="customHeader2">
        <h5>{Dismissing}</h5>
        <span>{DismissingMessage}</span>
      </div>
      <div slot="contentbody">
        <Alert dismissible color="primary" class="dark">
          <strong>Holy ! </strong>You can check in on some of those fields below.
        </Alert>
        {#each data.Dismissingdata as alertItem}
          <Alert dismissible color={alertItem.color} class="dark" >
            <strong>Holy ! </strong>{alertItem.title}
          </Alert>
        {/each}
      </div>
    </Card>
</Col>